import {
  ENTERPRISE_VOD_PLAN,
  MICRO_VOD_PLAN,
  PREMIUM_VOD_PLAN,
  PRO_VOD_PLAN,
  STARTER_VOD_PLAN,
} from '@studio/constants/library';
import type { Library } from '@studio/types';
import { useCustomer } from '@studio/storeV2/customer/hooks/use-customer';

const useIsVodPlanType = (): Library.Derived.VodPlanType => {
  const { vodPlanId } = useCustomer();
  const planId = vodPlanId || '';

  return {
    isEnterprise: planId === ENTERPRISE_VOD_PLAN,
    isMicro: planId === MICRO_VOD_PLAN,
    isPremium: planId === PREMIUM_VOD_PLAN,
    isPro: planId === PRO_VOD_PLAN,
    isStarter: planId === STARTER_VOD_PLAN,
    vodPlanId: planId,
  };
};

export default useIsVodPlanType;
